import { styled } from "@mui/material/styles";
import { grey } from "designSystem/styles/color";
import { useHover } from "designSystem/hooks";
import { Box, CsiImage, DataGridCardProps, FlexRowCenter, OverflowText, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { C8Node } from "csi/typings";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import { usePresentationPageStore } from "../main";
import { useProductGalleryStore } from "./ProductGalleryStore";

const PREFIX = "PPProductSlimCard";

const classes = {
	root: `${PREFIX}root`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)((
	{
		theme,
	},
) => ({
	[`&.${classes.root}`]: {
		border: STANDARD_BORDER_STYLE,
		borderRadius: 3,
		height: 80,
		position: "relative",
	},
}));

export interface PPProductSlimCardProps extends DataGridCardProps<C8Node> {
	/** indicate if need to allow to switch through images */
	disableSwitchNodeImages?: boolean;
}

export const PPProductSlimCard: FunctionComponent<PPProductSlimCardProps> = observer((props) => {
	const { disableSwitchNodeImages, item } = props;

	const { violationUrlsOfProduct } = usePresentationPageStore();

	const productHasViolation = violationUrlsOfProduct?.has(item.$URL);
	const hoverRef = useRef(null);
	const hovering = useHover(hoverRef);

	const {
		getColorSpecs,
		getDefaultColorSpec,
		getImageNode,
	} = useProductGalleryStore();

	const colors = getColorSpecs(item, productHasViolation, null);
	const defaultColor = getDefaultColorSpec(item, productHasViolation, colors, null);
	const imageNode = getImageNode(defaultColor || colors[0]);

	return (
		<StyledFlexRowCenter className={classes.root} {... { ref: hoverRef }}>
			<CsiImage
				allowSwitchNodeImages={!disableSwitchNodeImages}
				aspectRatio={1}
				displayControls={hovering}
				noImageComponent={(
					<Text
						lineHeight={16}
						res="NoImageAvailable"
						semiBold
						size={14}
						style={{ color: grey[800] }}
					/>
				)}
				node={imageNode}
				width={78}
			/>
			{/**   need minWidth = 0 to make the text truncated as expected https://css-tricks.com/flexbox-truncated-text/  */}
			<Box minWidth={0} p={3}>
				<OverflowText
					bold
					lineHeight={16}
					size={14}
					text={item.$Name}
				/>
			</Box>
		</StyledFlexRowCenter>
	);
});

export default PPProductSlimCard;